import { Button } from "components";
import "./online-restored-notice.scss";

interface OnlineRestoredNoticeProps {
  title?: string;
  message: string;
  onActionClick?: () => void;
  actionLabel?: string;
}

const OnlineRestoredNotice = ({
  title = "Przywrócono połączenie z internetem",
  message,
  onActionClick,
  actionLabel = "Przejdź do synchronizacji",
}: OnlineRestoredNoticeProps) => {
  const handleClick = () => {
    if (onActionClick) {
      onActionClick();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="online-restored-notice">
      <div className="online-restored-notice__container">
        <div className="online-restored-notice__icon"></div>
        <h2 className="online-restored-notice__title">{title}</h2>
        <p className="online-restored-notice__description">{message}</p>
        <div className="online-restored-notice__actions">
          <Button onClick={handleClick} label={actionLabel} />
        </div>
      </div>
    </div>
  );
};

export default OnlineRestoredNotice;
